import swallowingStyled from '../../../utils/swallowingStyled';
import buttonStyle from '../utils/buttonStyle';
import { SWALLOWED_PROPS } from '../constants';

const StyledButton = swallowingStyled(
  'button',
  SWALLOWED_PROPS,
)`${buttonStyle}`;

export default StyledButton;
